import algoliasearch from 'algoliasearch/lite';

// Initialize the client
export const searchClient = algoliasearch(
  'PXDT8L9IBU', // Your Algolia app ID
  'c1189872fe361c554ecf7ad81d9cf858' // Your search-only API key
);

export const ALGOLIA_INDEX_NAME = 'prod_de_attributes'; // Your index name